import { Route, Routes, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { CookieConsent } from './components/CookieConsent';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { DashboardPage } from './pages/Dashboard';
import { ContactsPage } from './pages/Contacts';
import { LeadsPage } from './pages/Leads';
import { DealsPage } from './pages/Deals';
import { TasksPage } from './pages/Tasks';
import { AutomationsPage } from './pages/Automations';
import { AnalyticsPage } from './pages/Analytics';
import { ProfilePage } from './pages/Profile';
import { ImportPage } from './pages/Import';
import { IntegrationsPage } from './pages/Integrations';

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="contacts" element={<ContactsPage />} />
                <Route path="leads" element={<LeadsPage />} />
                <Route path="deals" element={<DealsPage />} />
                <Route path="tasks" element={<TasksPage />} />
                <Route path="automations" element={<AutomationsPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="import" element={<ImportPage />} />
                <Route path="*" element={<Navigate to="dashboard" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          loading ? (
            <div className="page-loading">Loading your workspace…</div>
          ) : (
            <Navigate to={user ? '/dashboard' : '/login'} replace />
          )
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <CookieConsent />
    </AuthProvider>
  );
}
